import { Component, inject, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { PackLimitationsService } from '../../services/pack-limitations.service';
import { LimitedFeatures } from '../../models/pack.models';

@Component({
  selector: 'app-locked-button',
  imports: [ButtonModule, TooltipModule, TranslocoPipe],
  templateUrl: './locked-button.component.html',
})
export class LockedButtonComponent {
  packLimitationService = inject(PackLimitationsService);
  @Input() label: string = '';
  @Input() limitedFeature!: LimitedFeatures;
  @Input() fluid?: boolean = false;
}
